import { fileApi } from '@/api/file';

export const loadSpecialProjectPreviewHtml = async (
  projectId: string | number | null | undefined,
) => {
  if (!projectId) return '';

  try {
    const files = await fileApi.listFiles({
      projectId: Number(projectId),
      path: 'dist',
    });
    const indexFile = files.find((file) => file.name === 'index.html' && !file.directory);
    if (!indexFile) return '';

    const targetPath = indexFile.path.startsWith('dist/')
      ? indexFile.path
      : `dist/${indexFile.path}`;
    const fileContent = await fileApi.readFile({
      projectId: Number(projectId),
      path: targetPath,
    });

    return fileContent.content || '';
  } catch (error) {
    console.warn(
      '[specialProjectPreview] Failed to load local special-project preview HTML:',
      error,
    );
    return '';
  }
};
